export default function (): boolean {
  if (window.matchMedia) {
    const res = window.matchMedia('(min-width: 768px)');
    return res?.matches;
  }
  return window.innerWidth >= window.innerHeight;
}
